import { Button } from '@foam/buoy/src/components/Button/Button';
import { useRouter } from 'next/router';
import { MockMetrics } from '~/components/CreatorChannelMetrics/MockMetrics';
import { SOCIAL_PLATFORMS } from '~/constants';

import { PlatformDemographics } from './PlatformDemographics';

interface Props {
  isDemographicsDisabled: boolean;
  platform: SOCIAL_PLATFORMS;
  slug: string;
  isConnected: boolean;
  isCreator?: boolean;
}

export const AnalyticsEmptyState: React.FC<Props> = ({
  isDemographicsDisabled,
  platform,
  slug,
  isConnected,
  isCreator = false,
}) => {
  const router = useRouter();

  const navigateToConnections = () => {
    router.push(`/t/${slug}/platform-connections`);
  };

  const getNotConnectedMessage = () => {
    if (isCreator) {
      return 'Connect your social accounts to unlock real-time, auto-updating metrics.';
    }
    return 'Add real-time, auto-updating metrics by having the Talent connect their social accounts—no more requesting screenshots.';
  };

  return (
    <div className="relative">
      <div className="pointer-events-none select-none opacity-30">
        <div className="flex flex-col gap-6">
          <PlatformDemographics
            isDemographicsDisabled={isDemographicsDisabled}
          />
          <MockMetrics platform={platform} />
        </div>
      </div>
      <div className="absolute inset-0 z-20 flex items-center justify-center p-4">
        <div className="flex max-w-[600px] flex-col items-center gap-4 text-center">
          <h3
            className="text-20 font-500"
            style={{
              textShadow: '0 0 10px white, 0 0 20px white, 0 0 30px white',
            }}
          >
            {!isConnected
              ? getNotConnectedMessage()
              : 'Detailed analytics for this Talent are currently unavailable. Please try again later.'}
          </h3>
          {!isConnected && (
            <Button size="lg" onClick={navigateToConnections}>
              Connect
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
